import { render, staticRenderFns } from "./DriverRollouts.vue?vue&type=template&id=145817ce&"
import script from "./DriverRollouts.vue?vue&type=script&lang=ts&"
export * from "./DriverRollouts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports